import React from 'react';
import { siteData } from '../data/site';
import heroImageFallback from '../assets/foto centro.webp';

const HERO_IMG =
  'https://image.pollinations.ai/prompt/Hero%20illustration%20for%20pediatric%20therapy%20center%2C%20warm%20and%20playful%2C%20children%20playing%20with%20therapist%2C%20soft%20watercolor%20style%2C%20pastel%20colors%20pink%20blue%20purple%2C%20child-friendly%2C%20occupational%20therapy%20speech%20therapy%2C%20kite%20motif%20in%20background%2C%20professional%20medical%20illustration%2C%20no%20text%2C%20wide%20banner%20format?model=flux&seed=688171&width=1400&height=700';

const UsersIcon = () => (
  <svg className="w-6 h-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const HeartIcon = () => (
  <svg className="w-6 h-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
  </svg>
);

const BadgeIcon = () => (
  <svg className="w-6 h-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
  </svg>
);

const StarIcon = () => (
  <svg className="w-5 h-5 text-primary" fill="currentColor" viewBox="0 0 20 20">
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
  </svg>
);

const KiteIcon = () => (
  <svg className="w-8 h-8 text-primary/60" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 2L4 12l8 10 8-10L12 2z M12 2v20 M4 12h16" />
  </svg>
);

const Hero = () => {
  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center pt-20 pb-16 overflow-hidden bg-gradient-to-br from-[#f8f0ff] via-white to-[#fff0f6]"
    >
      {/* Background blobs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-secondary/20 rounded-full blur-3xl pointer-events-none -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-[30rem] h-[30rem] bg-background/40 rounded-full blur-3xl pointer-events-none translate-x-1/3 translate-y-1/3" />
      <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-primary/5 rounded-full blur-3xl pointer-events-none" />

      <div className="container-custom relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left: Content */}
          <div className="space-y-8 text-center lg:text-left">

            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-secondary/50 text-text px-4 py-2 rounded-full text-sm font-semibold">
              <KiteIcon />
              <span>Centro de Terapia Infantil · Las Condes</span>
            </div>

            {/* Headline */}
            <div className="space-y-3">
              <h1 className="font-fredoka text-5xl sm:text-6xl lg:text-7xl text-text leading-tight">
                Centro{' '}
                <span className="text-primary relative">
                  Volantín
                  <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 200 8" fill="none">
                    <path d="M2 6 Q50 2 100 5 Q150 8 198 4" stroke="#ffc7df" strokeWidth="3" strokeLinecap="round"/>
                  </svg>
                </span>
              </h1>
              <p className="text-xl lg:text-2xl text-text/80 font-semibold font-nunito">
                {siteData.tagline}
              </p>
              <p className="text-base lg:text-lg text-text/65 max-w-lg leading-relaxed font-nunito mx-auto lg:mx-0">
                {siteData.description}
              </p>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button
                onClick={() => window.open('https://encuadrado.com/centro/centro-volantin', '_blank')}
                className="btn-primary text-base px-8 py-4"
              >
                <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Agendar cita
              </button>
              <button
                onClick={() => document.getElementById('servicios').scrollIntoView({ behavior: 'smooth' })}
                className="btn-secondary text-base px-8 py-4"
              >
                Ver servicios
                <svg className="w-4 h-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-6 pt-2">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 bg-primary/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <UsersIcon />
                </div>
                <div>
                  <p className="font-fredoka text-2xl text-text leading-none">+200</p>
                  <p className="text-xs text-text/55 font-nunito">Familias atendidas</p>
                </div>
              </div>
              <div className="w-px h-10 bg-gray-200 hidden sm:block self-center" />
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 bg-secondary/50 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <HeartIcon />
                </div>
                <div>
                  <p className="font-fredoka text-2xl text-text leading-none">100%</p>
                  <p className="text-xs text-text/55 font-nunito">Atención personalizada</p>
                </div>
              </div>
              <div className="w-px h-10 bg-gray-200 hidden sm:block self-center" />
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 bg-background/70 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <BadgeIcon />
                </div>
                <div>
                  <p className="font-fredoka text-2xl text-text leading-none">3</p>
                  <p className="text-xs text-text/55 font-nunito">Profesionales</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            {/* Decorative rotated card behind the image */}
            <div className="absolute inset-0 bg-gradient-to-br from-secondary/60 to-background/60 rounded-[2.5rem] rotate-3 scale-105" />

            <img
              src={HERO_IMG}
              alt="Niños en terapia con profesionales del Centro Volantín"
              className="relative z-10 w-full rounded-[2rem] shadow-2xl object-cover"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = heroImageFallback;
              }}
            />

            {/* Floating rating badge */}
            <div className="absolute z-20 -bottom-5 -left-4 bg-white rounded-2xl shadow-xl px-4 py-3 flex items-center gap-3 border border-gray-100">
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => <StarIcon key={i} />)}
              </div>
              <div>
                <p className="font-fredoka text-text text-sm leading-none">5.0 de calificación</p>
                <p className="text-xs text-text/50 font-nunito">Familias satisfechas</p>
              </div>
            </div>

            {/* Decorative dots */}
            <div className="absolute -top-6 -right-6 w-16 h-16 bg-primary/15 rounded-2xl animate-float z-0" />
            <div className="absolute top-1/4 -right-8 w-8 h-8 bg-background rounded-full animate-bounce-slow z-0" />
            <div className="absolute bottom-1/4 -left-6 w-10 h-10 bg-secondary/60 rounded-xl animate-float z-0" style={{ animationDelay: '1s' }} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
